import { render, staticRenderFns } from "./SummaryProductAndPin.vue?vue&type=template&id=4dc9605c&scoped=true"
import script from "./SummaryProductAndPin.vue?vue&type=script&lang=js"
export * from "./SummaryProductAndPin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc9605c",
  null
  
)

export default component.exports